export default __webpack_public_path__ + "static/media/mega.547a8dae.svg";